import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import ModalDeleteStudent from "./modalDeleteStudent";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {getSchoolYear} from "../../../../utils/authority";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../services/system/student/student-controller";
import GradeManager from "../../../../components/Grade";
import ModalTransSchool from "./modalTransSchool";
import ModalTransClass from "./modalTransClass";

class StandardFeesManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            listClass: [],
            pageNumber: 0,
            pageSize: 10,
            classRoomId: -1,
            gradeId: "",
            gender: "",
            code: "",
            ethnic: "",
            fullName: "",
            studentState: "",
            isShowText: false,
            sort: 'id',
            descending: 'DESC',
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "types",
                    name: "Loại phí",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "code",
                    name: "Đơn vị tính",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "money",
                    name: "Số tiền",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Ghi chú",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "month",
                    name: "Tháng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "quy",
                    name: "Quý",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "ky",
                    name: "Kỳ",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "year",
                    name: "Năm",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListStudent()
        this.getListClass()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListStudent();
            }
        );
    };
    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            name: "",
            pageNumber: 0,
            pageSize: 200,
            sort: "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClass: res.data.content,
            });
        })
    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc"
        };
        StudentController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: parseInt(this.state.classRoomId),
            code: this.state.code,
            ethnic: this.state.ethnic,
            fullName: this.state.fullName,
            gender: this.state.gender,
            grade: this.state.gradeId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
            studentState: this.state.studentState,
        };
        StudentController.search(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
        });
    }
    renderClass() {
        return this.state.listClass.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        let {gradeId, isShowText, listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="stand-fees" parentClass="wallet-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Các loại phí tiêu chuẩn"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tên khoản phí</label>
                                                <input
                                                    placeholder="Nhập tên khoản phí"
                                                    name="fullName"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.fullName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({fullName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    <option value="MALE">Nam</option>
                                                    <option value="FEMALE">Nữ</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <LinkPlus
                                                    style={{color: '#000'}}
                                                    to={{
                                                        pathname: "/ad-sas-school/tao-moi-khoan-phi",
                                                        state: {
                                                            fromDashboard: true,
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </LinkPlus>

                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.setState({showModalCreate: true})}
                                                >
                                                    Xuất Excell
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListStudent()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.fullName}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.code}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.birthday ? moment(row.birthday).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.gender == "MALE"?"Nam": "Nữ"}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.ethnic == "KINH"?"Kinh": "Khác"}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.currentClassRoomRes?.name}
                                                            </td>

                                                            <td style={{textAlign: "left"}}>
                                                                {row.state}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.state}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/sua-khoan-phi",
                                                                        search: createSearchParams({
                                                                            id: `${row.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            id: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </LinkPlus>
                                                                <button className="btn btn-action p-2"
                                                                        title='Xóa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalDelete: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-trash"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteStudent
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
                <ModalTransSchool
                    show={this.state.showModalTransSchool}
                    onHide={() => this.setState({showModalTransSchool: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                    name={this.state.itemSelectedName}
                />
                <ModalTransClass
                    show={this.state.showModalTransClass}
                    onHide={() => this.setState({showModalTransClass: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                    name={this.state.itemSelectedName}
                />
            </div>
        );
    }
}

export default StandardFeesManagement;
